import React from 'react';

export default function DataKepulangan() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Data Kepulangan</h1>
      <p className="text-gray-500">Halaman Data Kepulangan</p>
    </div>
  );
}
